var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Zlib from "zlib";
export function neoUnzip(gzipped) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            try {
                // eslint-disable-next-line
                const gunzip = new Zlib.unzip(gzipped, (err, decompressed) => {
                    if (err) {
                        console.log(err);
                        reject(undefined);
                    }
                    else {
                        const ret = new Uint8Array(decompressed);
                        resolve(ret);
                    }
                });
            }
            catch (e) {
                reject(undefined);
            }
        });
    });
}
export function neoGunzip(gzipped) {
    return __awaiter(this, void 0, void 0, function* () {
        // for (let i = 0; i < gzipped.length; i += 16) {
        //   const rowLen = gzipped.length - i >= 16 ? 16 : gzipped.length - i;
        //   let str = "";
        //   for (let j = 0; j < rowLen; j++) {
        //     const ch = gzipped[i + j];
        //     let hex = "000" + ch.toString(16);
        //     hex = hex.slice(hex.length - 2);
        //     str = str + hex + " ";
        //   }
        //   let addr = "000000" + i.toString(16);
        //   addr = addr.slice(addr.length - 4);
        //   console.log(`${addr}: ${str}`);
        // }
        return new Promise((resolve, reject) => {
            try {
                // eslint-disable-next-line
                const gunzip = new Zlib.gunzip(gzipped, (err, decompressed) => {
                    if (err) {
                        console.log(err);
                        reject(undefined);
                    }
                    else {
                        const ret = new Uint8Array(decompressed);
                        resolve(ret);
                    }
                });
            }
            catch (e) {
                reject(undefined);
            }
        });
    });
}
/*

120, 156, 187, 201, 205, 192, 96, 19, 19, 226, 86, 197, 200, 192, 144, 24, 11, 161, 65, 224, 63, 35, 67, 201, 57, 166, 105, 12, 225, 12, 26, 194, 59, 125, 172, 25, 202, 118, 221, 185, 9, 84, 154, 176, 13, 162, 228, 192, 118, 20, 165, 107, 119, 48, 177, 50, 112, 50, 232, 74, 206, 142, 14, 98, 152, 179, 43, 18, 164, 212, 103, 31, 68, 137, 201, 126, 20, 165, 211, 30, 51, 49, 48, 48, 51, 48, 216, 214, 91, 88, 50, 76, 218, 245, 29, 164, 116, 243, 247, 48, …]
*/ 
//# sourceMappingURL=pen_gunzip.js.map